import { useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useChapterNavigation } from './useChapterNavigation';
import { useSummaryTabs } from './useSummaryTabs';
import { formatChapters, calculateExpectedChunks } from '../../utils';

/**
 * SummarySection의 모든 로직을 관리하는 메인 커스텀 훅
 * @param {object} props - SummarySection props
 * @returns {object} - 모든 필요한 상태와 함수들
 */
export const useSummarySectionHooks = ({ 
  activeTab, 
  setActiveTab, 
  playerRef, 
  detailContent, 
  transcript, 
  setActiveMainTab 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [errorDialog, setErrorDialog] = useState({ open: false, title: '', message: '' });

  // Chapter navigation hook
  const {
    scrollContainerRef,
    handleChapterClick,
    scrollToChapter
  } = useChapterNavigation(playerRef, isMobile, setActiveMainTab);

  // Summary tabs hook
  const { handleTabChange } = useSummaryTabs(activeTab, setActiveTab, scrollContainerRef);

  // 포맷팅된 챕터 내용
  const formattedDetailContent = formatChapters(detailContent);

  // 예상 청크 개수 계산
  const expectedChunks = calculateExpectedChunks(transcript);

  return {
    // UI 상태
    theme,
    isMobile,
    errorDialog,
    setErrorDialog,
    
    // 네비게이션 관련
    scrollContainerRef,
    handleChapterClick,
    scrollToChapter,
    
    // 탭 관련
    handleTabChange,
    
    // 데이터 포맷팅
    formattedDetailContent,
    expectedChunks
  };
}; 